import React, { useEffect, useState } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';

export default function IdentifyAmblyopia({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false)

  const newsData = [
    {
      title: '近视防控应该怎么做?',
      desc: <>
        首先判断是真性近视还是假性近视。<br />
        如果孩子出现"假性近视”，可以让孩子眼睛彻底放松，使眼睛慢慢恢复…
      </>,
      date: '2024-10-11',
      img: '/images/home/news4.png',
      route: '/fcst/identifyMyopia',
      type: '科普专栏',
    },
    {
      title: '理论突破 - 弱视的皮层下受损',
      desc: '弱视患者的一个重要临床表现在于弱视眼对空间细节的敏感度降低，包括视锐度（眼睛辨别最小视角的能力）降低；对比度敏感度，尤其是对高空间频率（细密纹理）的对比度敏感度降低。...',
      date: '2024-10-31',
      img: '/images/home/news2.png',
      route: '/fcst/breakthroughTheory',
      type: '文献速递',
    },
    {
      title: '方法突破 - 结合增强现实的，可以针对弱视眼P通路进行矫正的双眼图像算法',
      desc: 'Xu等人在2010年证明了通过使用推拉（Push-pull）方法来减少眼优势（sensory eye dominance）的可能性。在训练过程中（图 C），受试者的任务是辨别非优势眼看到中的光栅朝向。 刺激首先向受试者的非优势眼呈现一个矩形框（注意提示），然后分别向双眼呈现一对正交光栅。...',
      date: '2024-10-31',
      img: '/images/home/news1.png',
      route: '/fcst/breakthroughMethod',
      type: '文献速递',
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div>
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>FCST研究院 / 科普专栏 / 【科普】什么是弱视？</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/fcst', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                FCST研究院 / 科普专栏
                <span className='ml_54'>2024.10.31</span>
              </div>
              <div className="article_titleBottom">【科普】什么是弱视？</div>
            </div>
            <div className="article_content">
              <div className="article_content-text">
                弱视是一种视觉发育相关疾病，其特征为戴镜视力达不到同龄儿童正常视力下线或者两眼视力相差2行以上，且经眼科检查并未发现能够引起视力差的器质性病变。
              </div>
              <div>
                <img
                  style={{ width: '100%' }}
                  src='/images/fcst/identifyAmblyopia1.png'
                  alt=''
                />
              </div>
              <div className="article_content-text1">哪些孩子容易弱视？</div>
              <ul className="article_content-text">
                <li>斜视</li>
                <li>屈光不正</li>
                <li>一些影响视力的眼部疾病（如白内障）</li>
              </ul>
              <div className="article_content-text1">怎么发现自己的孩子患有弱视？</div>
              <div className="article_content-text">
                单纯的弱视通常没有明显的症状，并且发病较早，患儿不能清楚表达视力的缺陷，因此大多数的弱视都是在常规视力筛查中发现的；<br />
                若患儿立体视力缺损较为严重，会在早期出现对物品的距离把握不准的现象，表现为不能准确拿到不同距离的物品等，但随着患儿成长，
                逐步会利用其他细节（如大小，深度等）判断距离则不容易观察到该症状。因此一旦发现孩子出现类似的倾向，应及时去往正规的眼科医院检查；<br />
                此外由斜视或者白内障等眼病引起的弱视，一般都是先发现斜视等原发疾病，再进一步确诊弱视。
              </div>
              <div className="article_content-text1">弱视应该如何治疗？</div>
              <div className="article_content-text">
                弱视的治疗应在对儿童管理眼部疾病经验丰富的眼科医生引导下进行。<br />
                大部分弱视的患者都应该优先治疗原发疾病，包括矫正屈光度（眼镜或隐形眼镜）、摘除白内障等。<br /><br />
                在消除病因之后就应该开始弱视治疗，目前应用最广泛的治疗手段是单眼遮盖，通过压抑好眼睛（遮盖、压抑膜），弱化好眼的注视功能，
                让出机会给差眼，刺激差眼锻炼，增强功能，以提高视力。但是遮盖法本身存在一定的局限性，一个是对12岁以上的患者几乎无效，
                另一个则是无法有效帮助弱视患者建立立体视等高阶视功能。
              </div>
              <div className='PreA_img2'>
                <img
                  style={{ width: '100%' }}
                  src='/images/fcst/identifyAmblyopia2.png'
                  alt=''
                />
              </div>
              <div className="article_content-text1">ARTA 埃尔塔™ 是什么？</div>
              <div className="article_content-text">
                {/* 集视医疗针对目前弱视治疗的不足，开发出的全年龄弱视治疗仪，是目前市面上唯一一款疗效优于遮盖法的弱视治疗产品，并且突破了既往临床弱视治疗的年龄限制，将治疗年龄拓宽到了55周岁。<br />
                埃尔塔™已于2024年10月上市，为更多临床“不可治愈”的弱视患者带来新的希望。 */}
                集视医疗针对目前弱视治疗的不足，开发出的视觉功能训练治疗软件，是目前市面上唯一一款疗效优于遮盖法的弱视治疗产品，并且突破了既往临床弱视治疗的年龄限制，将治疗年龄拓宽到了55周岁。<br />
                埃尔塔™已于2024年10月上市，为更多临床“不可治愈”的弱视患者带来新的希望。
              </div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/breakthroughMethod'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇文章
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/identifyMyopia'))}
              >
                阅读下一篇文章
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/breakthroughMethod'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/fcst/identifyMyopia'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="PreA_right">
        <div className="PreA_marginMobile">
          <div className='PreA_right-searchBlock flex_row flex_ai-c'>
            <div className='of_hidden' style={{ width: '100%' }}>
              <input
                className="PreA_input flex_full"
                style={{ width: '100%' }}
                type="text"
                // value={demand}
                // onChange={(e) => setDemand(e.target.value)}
                placeholder="搜索文章"
              />
              <div className='PreA_input-line'></div>
            </div>
            <img
              className='PreA_right-icon flex_auto'
              src='/images/news/right.png'
              alt=''
            />
          </div>
          <div className="article_rightType">
            <div className='fz_18 fw_500 lh_21'>文章分类</div>
            <div className='PreA_right-item flex_center'>科普专栏</div>
          </div>
          <div className="article_rightMore">
            <div className='fz_18 fw_500 lh_21'>更多文章</div>
            <div className="mt_16">
              <div className="of_hidden">
                <div className='article_rightMoreBlock flex_col'>
                  {newsData.map((item, index) => <div
                    key={index}
                    className='article_rightItem cur_p'
                    onClick={(() => navigate(item.route))}
                  >
                    <div className="article_rightItemBlock">
                      <div className='PreA_right-itemImg flex_center'>
                        <img
                          style={{ width: '100%' }}
                          src={item.img}
                          alt=''
                        />
                      </div>
                      <div className='article_rightItem-date c_85899E flex_row flex_jc-sb'>
                        <div>{item.date}</div>
                        <div className='article_rightItem-type'>FCST研究院 / {item.type}</div>
                      </div>
                      <div className='article_rightItem-title of_ellipsis'>{item.title}</div>
                      <div className='article_rightItem-desc multiline-ellipsis-2'>{item.desc}</div>
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
            <div className="PreA_right-btnBlock">
              <div
                className='PreA_right-btn flex_row flex_jc-c flex_ai-c'
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={(() => navigate('/fcst'))}
              >
                更多文章
                <img
                  class="PreA_right-arrow"
                  alt=""
                  src={hovered ? '/images/home/arrow-right-whiteLine.png' : '/images/home/arrow-right-blackLine.png'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
}
